import React from 'react'

const ThreeDotsMenuVertical = () => (
  <svg
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.78613 16.8206C9.78613 17.7427 10.6071 18.4971 11.6105 18.4971C12.6138 18.4971 13.4348 17.7427 13.4348 16.8206C13.4348 15.8985 12.6138 15.1441 11.6105 15.1441C10.6071 15.1441 9.78613 15.8985 9.78613 16.8206Z"
      stroke="#4F5B94"
      stroke-width="1.5"
    />
    <path
      d="M9.78613 5.08525C9.78613 6.00731 10.6071 6.76172 11.6105 6.76172C12.6138 6.76172 13.4348 6.00731 13.4348 5.08525C13.4348 4.16319 12.6138 3.40878 11.6105 3.40878C10.6071 3.40878 9.78613 4.16319 9.78613 5.08525Z"
      stroke="#4F5B94"
      stroke-width="1.5"
    />
    <path
      d="M9.78613 10.9529C9.78613 11.875 10.6071 12.6294 11.6105 12.6294C12.6138 12.6294 13.4348 11.875 13.4348 10.9529C13.4348 10.0309 12.6138 9.27645 11.6105 9.27645C10.6071 9.27645 9.78613 10.0309 9.78613 10.9529Z"
      stroke="#4F5B94"
      stroke-width="1.5"
    />
  </svg>
)

export default ThreeDotsMenuVertical
